/**
 * Copy localized / plan-metafield gallery images into the product lightbox.
 * Also stamps hero 2 (90D vs 30D) onto the matching gallery slide so the
 * popup does not keep the 30D price on the second image.
 */
(function () {
  if (window.__im8PopupLocalize) return;
  window.__im8PopupLocalize = true;

  function capUrl(url, maxW) {
    if (!url) return url;
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + maxW);
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + maxW;
  }

  function attr(value) {
    return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function fingerprint(url) {
    if (!url) return '';
    var pathname = String(url).split('?')[0];
    try { pathname = new URL(url, window.location.href).pathname; } catch (e) {}
    var stem = decodeURIComponent(pathname).split('/').pop().split('.')[0].toLowerCase();
    var parts = stem.split('_');
    if (parts[parts.length - 1] && parts[parts.length - 1].length === 36) parts.pop();
    return parts.join('_');
  }

  function galleryRoot() {
    return document.querySelector('.Product_template_latest_inner_new media-gallery')
      || document.querySelector('media-gallery');
  }

  function modalRoot() {
    return document.querySelector('product-modal.product-media-modal');
  }

  function popupImgForSlide(modal, slideDataId) {
    if (!modal || !slideDataId) return null;
    var mediaId = String(slideDataId).split('-').pop();
    var container = modal.querySelector('[data-media-id="' + attr(slideDataId) + '"]');
    if (container) {
      if (container.tagName === 'IMG') return container;
      var inner = container.querySelector('img');
      if (inner) return inner;
    }
    return modal.querySelector('img[data-media-id="' + attr(mediaId) + '"]');
  }

  function currentPlan(variantMap) {
    var vid = new URLSearchParams(window.location.search).get('variant');
    if (!vid) {
      var input = document.querySelector('product-info input[name="id"], product-form input[name="id"]');
      vid = input ? input.value : null;
    }
    return (vid && variantMap && variantMap[vid]) || '30d';
  }

  function applyHero2() {
    var dataEl = document.getElementById('im8-hero-override-data');
    var gallery = galleryRoot();
    if (!dataEl || !gallery) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var urls = data.urls && data.urls.hero2;
    if (!urls) return;
    var plan = currentPlan(data.variantMap);
    var url = urls[plan] || null;
    // Preview cover owns slot 1; preserve its photo in slot 2 instead of
    // racing the hero runtime and restoring obsolete welcome-kit artwork.
    if (data.postOfferCovers && plan !== 'one_time') {
      if (data.postOfferHero2) url = data.postOfferHero2;
      else if (data.welcomeKitFirst && data.urls.hero1) url = data.urls.hero1[plan] || url;
    }
    var mainList = gallery.querySelector('.product__media-list');
    if (!mainList) return;
    var slides = Array.from(mainList.querySelectorAll(':scope > .product__media-item'));
    var hero2 = slides.find(function (slide) {
      var img = slide.querySelector('img');
      if (!img) return false;
      var id = slide.getAttribute('data-media-id') || '';
      if (id.indexOf('quarterly-alt') !== -1) return false;
      return [img.currentSrc, img.src, img.getAttribute('src'), img.dataset.im8HeroOriginalSrc]
        .some(function (src) {
          var fp = fingerprint(src);
          return fp && (fp === fingerprint(urls['30d']) || fp === fingerprint(urls['90d']));
        });
    });
    if (!hero2) {
      hero2 = slides.filter(function (slide) {
        return (slide.getAttribute('data-media-id') || '').indexOf('quarterly-alt') === -1;
      })[1];
    }
    if (!hero2) return;
    var img = hero2.querySelector('img');
    if (!img || !url) return;
    var capped = capUrl(url, 1200);
    if (img.getAttribute('src') === capped) return;
    if (!img.dataset.im8HeroOriginalSrc) img.dataset.im8HeroOriginalSrc = img.src || '';
    img.src = capped;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    var slideDataId = hero2.getAttribute('data-media-id');
    if (!slideDataId) return;
    gallery.querySelectorAll(
      '.thumbnail-list [data-target="' + attr(slideDataId) + '"] img, [id="Thumbnail-' + attr(slideDataId) + '"] img'
    ).forEach(function (thumb) {
      thumb.src = capUrl(url, 416);
      thumb.removeAttribute('srcset');
      thumb.removeAttribute('sizes');
    });
  }

  function syncPopup() {
    var gallery = galleryRoot();
    var modal = modalRoot();
    if (!gallery || !modal) return;
    var gallerySlides = gallery.querySelectorAll('.product__media-item[data-media-id]');
    var popupSlides = modal.querySelectorAll('.Product_popup_slider .swiper-slide');
    gallerySlides.forEach(function (slide, i) {
      var srcImg = slide.querySelector('img');
      if (!srcImg) return;
      var url = srcImg.dataset.igSrc || srcImg.getAttribute('src') || '';
      if (!url || url.indexOf('data:') === 0) return;
      var capped = capUrl(url, 1445);
      var popupImg = popupImgForSlide(modal, slide.getAttribute('data-media-id'));
      if (!popupImg && popupSlides[i]) popupImg = popupSlides[i].querySelector('img');
      if (!popupImg) return;
      if (popupImg.getAttribute('src') === capped) return;
      popupImg.src = capped;
      popupImg.removeAttribute('srcset');
      popupImg.removeAttribute('sizes');
    });
  }

  function run() {
    applyHero2();
    syncPopup();
  }

  function boot() {
    run();
    document.addEventListener('change', function (e) {
      if (e.target && (e.target.matches('input[name="id"]') || e.target.matches('input[data-variant-id]'))) {
        requestAnimationFrame(run);
        setTimeout(run, 250);
        setTimeout(run, 600);
      }
    });
    document.addEventListener('variant:change', function () {
      setTimeout(run, 50);
      setTimeout(run, 300);
    });
    var gallery = galleryRoot();
    if (gallery && window.MutationObserver) {
      var timer = null;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(run, 50);
      }).observe(gallery, { subtree: true, attributes: true, attributeFilter: ['src'] });
    }
    setTimeout(run, 120);
    setTimeout(run, 450);
    setTimeout(run, 1100);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
